<template>
  <div class="home">

    <transition name="result" mode="out-in">
      <div v-if="hasCards" class="home-desc">
        <div :style="`opacity: ${opacity};`" v-if="Math.abs(likeRatio) <= 0.2" class="home-company">{{name}} <span>by</span> {{by}}</div>
        <div v-if="likeRatio > 0.2" class="home-like">Нравится</div>
        <div v-if="likeRatio < -0.2" class="home-unlike">Не нравится</div>
      </div>
    </transition>

    <transition name="result" mode="out-in">
      <div v-if="hasCards" class="home-count">
        <div class="home-countWrapper" :style="`opacity: ${opacity};`">
          {{count}}<span>/</span>{{length}}
        </div>
      </div>
    </transition>

    <HomeResult v-if="!hasCards" :images="result"/>

    <div :style="`opacity: ${opacity};`" v-if="hasCards" class="home-tinder">
      <tinder ref="tinder" :queue.sync="queue" @submit="submit" @move="move">
        <template slot-scope="{data}">
          <div class="tinder-item" :style="`background-image: url('${data.url}')`"></div>
          <!-- <img class="tinder-img" :src="data.url"> -->
        </template>
        <img class="like-pointer" slot="like" src="../assets/like.svg">
        <img class="nope-pointer" slot="nope" src="../assets/unlike.svg">
        <img class="super-pointer" slot="super" src="../assets/like.svg">
      </tinder>
    </div>

    <HomeIntro ref="intro"/>

  </div>
</template>

<script>
import rawData from '@/js/TinderData'
// import Tinder from 'vue-tinder'
import _ from 'underscore'
import HomeIntro from '@/components/HomeIntro'
import HomeResult from '@/components/HomeResult'
import VueTinder from 'vue-tinder'
import Vue from 'vue'

const Tinder = Vue.component('tinder', {
  extends: VueTinder,
  computed: {
    pointerOpacity () {
      this.$emit('move', {ratio: this.state.ratio})
      return this.state.ratio / this.pointerThreshold
    },
  }
})

var data = _.sample(rawData, 10)

export default {
  name: 'Home',
  components: {
    Tinder,
    HomeIntro,
    HomeResult,
  },
  data () {
    return {
      queue: data.map(item => {
        item.key = Math.random()
        return item
      }),
      liked: [],
      opacity: 0,
      likeRatio: 0,
      moveCount: 0
    }
  },
  computed: {
    count () {
      const count = data.length - this.queue.length + 1;
      return (count > data.length) ? data.length : count;
    },
    length () {
      return data.length
    },
    name () {
      return data[this.count - 1].name
    },
    by () {
      return data[this.count - 1].by
    },
    hasCards () {
      // return false
      return (this.queue.length > 0)
    },
    result () {
      // return _.sample(this.queue, 7)
      return this.liked
    }
  },
  created () {
    // this.queue.forEach(this.preloadImage)
  },
  mounted () {
    setTimeout((() => {
      TweenMax.to(this, 0.2, {opacity: 1})
    }).bind(this), 4000);
  },
  methods: {

    preloadImage (item) {
      const img = new Image();
      img.src = item.url;
    },

    decide (choice) {
      this.$refs.tinder.decide(choice)
    },

    move (data) {
      this.likeRatio = data.ratio
      if (this.moveCount < 30) {
        this.moveCount++;
      } else {
        this.$refs.intro.stop()
      }
    },

    end () {

    },

    submit (choice) {
      if (choice.type === 'like' || choice.type === 'super') {
        this.liked.push(choice.item);
      }
      if (this.queue.length < 1) {
        this.end()
      }
    }
  }
}
</script>

<style lang="scss">
@import '../scss/settings';
@import '../scss/mixins';

.home {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

.home-desc {
  position: absolute;
  bottom: $padding;
  left: $padding;
  right: 90px;
  span {
    color: rgba(#000, 0.4);
  }
}

.home-count {
  position: absolute;
  bottom: $padding;
  right: $padding;
  span {
    padding: 0 2px;
  }
}

.home-tinder {
  width: 100%;
  height: 100%;
  // position: absolute;
  // overflow: hidden;
  max-width: 600px;
  margin: auto;
}


[v-cloak] { display: none; }

.vue-tinder {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  padding-bottom: 100%;
}

.nope-pointer { right: 10px; }
.like-pointer { left: 10px; }
.nope-pointer,
.like-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  width: 64px;
  height: 64px;
}
.super-pointer {
  position: absolute;
  z-index: 1;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
  width: 112px;
  height: 78px;
}

.tinder-card {
  border-radius: 0 !important;
  height: auto !important;
  box-shadow: none !important;
  background: transparent !important;
  transform: scale3d(0.90, 0.90, 1);
  .tinder-img {
    width: 100%;
  }
}

.tinder-item {
  @include contain('/');
  background-color: transparent;
  padding-bottom: 100%;
}

.pointer-wrap {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  img {
    height: 124px;
    width: 124px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-64px, -64px);
  }
}

.home-result {
  padding-top: 100px;
  @include container();
  a {
    text-decoration: none;
    border-bottom: 1px solid #d8d8d8;
  }
}

.home-collage {
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  overflow-x: hidden;
  margin-bottom: -15%;
  img {
    position: absolute;
    max-width: 50%;
    height: auto;
    box-shadow: 0 2px 24px 0 rgba(0,0,0,0.05);
  }
}

.result-enter-active {
  transition: opacity 300ms ease, transform 300ms ease;
}

.result-leave-active {
  transition: opacity 300ms ease, transform 300ms ease;
}

.result-enter, .result-leave-to {
  opacity: 0;
  transform: scale(1) translateY(7px);
}


</style>



// WEBPACK FOOTER //
// src/components/Home.vue